import {logger, UUID} from 'yougile-util'
import {DataObjectId, Hub, SandboxTree} from 'yougile-model'
import {PermissionsChecker} from '@client/permissions-checker'
import {DirectMessages} from '../../../client/direct-messages'
import {Sync} from '../../../client/sync'
import {SyncEvents} from '../../../client/sync-events'
import {ChatUtils} from '../../../extensions/chat-utils'
import {globals} from '../../../extensions/globals-base'
import {ChatProxy} from '../../../extensions/proxies/chat-proxy'

export const chatsCache: Map<DataObjectId, ChatProxy[]> = new Map()
const canShowEmptyHintCache: Map<DataObjectId, boolean> = new Map()
let listener: UUID
let profileListener: number
export const ensureCacheInitialized = (): void => {
  if (!listener) {
    listener = SyncEvents.addAnyListener(companyId => {
      chatsCache.delete(companyId)
      if (canShowEmptyHintCache.get(companyId)) {
        canShowEmptyHintCache.delete(companyId)
      }
    })
  }
  if (!profileListener) {
    profileListener = SyncEvents.addListener(Sync.profileId, '*', res => {
      const profile = Sync.getProfile()
      const directCnt = DirectMessages.getDirectChatsContainer()
      if (!directCnt || !profile) {
        return
      }
      for (const upd of res) {
        for (const id of upd.ids) {
          // user company settings changed
          if (id === globals.getCompanyId() || id === profile.companyId) {
            logger.log('Clear cache on company settings change')
            chatsCache.clear()
            return
          }

          const obj = profile.get(id)
          if (obj instanceof Hub) {
            if (obj.location === directCnt.id) {
              logger.log('Clear cache on profile update')
              chatsCache.clear()
              return
            }
          }
        }
      }
    })
  }
}

export const getCanShowEmptyHint = (box: SandboxTree): boolean => {
  if (canShowEmptyHintCache.has(box.companyId)) {
    return canShowEmptyHintCache.get(box.companyId)
  }
  const allTaskChats = ChatUtils.taskChatHubsGroupedByCurrentUserPresence(box)
  const hasCompanyChats =
    allTaskChats.withCurrentUser.length ||
    allTaskChats.withoutCurrentUser.length
  const canShowEmptyHint = PermissionsChecker.isAdmin() && !hasCompanyChats
  canShowEmptyHintCache.set(box.companyId, canShowEmptyHint)
  return canShowEmptyHint
}
